import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { IColumnDefinition } from '../../common/models/column-definition';

@Injectable()
export class MyActivitiesTableHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService
  ) { }

  getSelectedColumns(widgetInstanceId: number): Observable<Array<IColumnDefinition>> {

    const url = this.urlBuilder.getUrl(`myactivities/${widgetInstanceId}/table/selectedcolumns`);

    return this.http
      .get<IColumnDefinition[]>(url).pipe(
        map(table => table || undefined)
      );
  }

}
